import React from "react";
import { FaCheckCircle } from "react-icons/fa";

function SmartContracts() {
  return (
    <>
      <div className="about-area pt-5 pb-5 mt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center mb-5">
              <h2 className="title fw-bold">
                Tezos Blockchain Development Services by Xeer Technology
              </h2>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-5 text-center">
              <div className="thumb">
                <img
                  src="/assets/img/illustration/3.png"
                  alt="Launch DeFi Staking"
                  style={{ maxWidth: "80%" }}
                />
              </div>
            </div>
            <div className="col-lg-6 offset-lg-1">
              <div className="">
                <p
                  style={{
                    fontSize: "16px",
                    color: "#555",
                    marginBottom: "30px",
                  }}
                >
                  Our team of Tezos blockchain experts is here to guide your
                  journey in Web3 innovation. Partner with Xeer Technology to
                  create scalable, secure, and community-driven applications on
                  Tezos.
                </p>

                <ul className="list-unstyled">
                  <li className="d-flex mb-4 align-items-start">
                    <div className="icon text-primary mt-1 me-3">
                      <FaCheckCircle size={18} />
                    </div>
                    <div>
                      <h5 className="fw-bold fs-6 mb-1">Smart Contracts</h5>
                      <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>
                        for secure and automated interactions
                      </p>
                    </div>
                  </li>

                  <li className="d-flex mb-4 align-items-start">
                    <div className="icon text-primary mt-1 me-3">
                      <FaCheckCircle size={18} />
                    </div>
                    <div>
                      <h5 className="fw-bold fs-6 mb-1">
                        Community-Driven Governance
                      </h5>
                      <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>
                        to enable flexible and sustainable growth
                      </p>
                    </div>
                  </li>

                  <li className="d-flex mb-4 align-items-start">
                    <div className="icon text-primary mt-1 me-3">
                      <FaCheckCircle size={18} />
                    </div>
                    <div>
                      <h5 className="fw-bold fs-6 mb-1">Innovative Design</h5>
                      <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>
                        for future-proof blockchain solutions
                      </p>
                    </div>
                  </li>
                </ul>

                <a href="#" className="btn btn-style-one mt-3">
                  Talk to our Experts
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SmartContracts;
